import { Dropdown } from 'pepsico-ds'
import React from 'react'

function MultiSelectDropdown({ className = 'buy-con-dropdown', placeholder, childList, label, selectedValue, setSelectedValue, disabled=false, helperText="" }) {
    if(label==="Business Unit / Market") {
      //  console.log(childList, selectedValue)
    }
    return (
        <>
            <div className='buy-con-dropdown-label' disabled={disabled}>{label}</div>
            <Dropdown
                childList={childList}
                dropdownHeader="Menu List"
                isClearable={true}
                placeholder={placeholder}
                selection="multiple"
                size="medium"
                className={className}
                selectedValue={selectedValue}
                setSelectedValue={val => setSelectedValue(val)}
                hideMenuListOnSelection = {false}
                disabled={disabled}
                helperText={helperText}
                showInLineFeedback
            />
        </>
    )
}

export default MultiSelectDropdown